/** Input types that never open the on-screen keyboard. */
const NON_TEXT_INPUT_TYPES = new Set([
  'button',
  'checkbox',
  'color',
  'file',
  'hidden',
  'image',
  'radio',
  'range',
  'reset',
  'submit',
]);

/**
 * Whether focusing `el` opens the on-screen keyboard (text-like inputs,
 * textarea, contenteditable). The mobile tab bar hides meanwhile (SHELL-10).
 */
export function isTextEntryTarget(
  el: { tagName: string; type?: string; isContentEditable?: boolean } | null
): boolean {
  if (!el) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName.toUpperCase();
  if (tag === 'TEXTAREA') return true;
  if (tag !== 'INPUT') return false;
  return !NON_TEXT_INPUT_TYPES.has((el.type ?? 'text').toLowerCase());
}
